module.exports = __webpack_public_path__ + "img/song.6d131f5c.png";